module.exports = __webpack_public_path__ + "static/headerRightBg375-d3bd9b47795acdd47ab947f823c03480.png";